
const formatCurrency = (value) => {
    if (value === null || value === undefined || isNaN(parseFloat(value))) {
        return "0.00";
    }
    return parseFloat(value).toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });
}
const AssociatedInsuranceInformation = ({data}) =>{
    return(
        <div className="overflow-x-auto w-full">
        <table className="min-w-full bg-white border border-gray-200">
            <thead>
                <tr className="bg-gray-100 border-none text-[#94A3B8]">
                    <th className="py-2 md:py-3 px-2 md:px-3 text-start text-xs md:text-base whitespace-nowrap">Ref ID</th>
                    <th className="py-2 md:py-3 px-2 md:px-3 text-start text-xs md:text-base whitespace-nowrap">Coverage Type</th>
                    <th className="py-2 md:py-3 px-2 md:px-3 text-start text-xs md:text-base whitespace-nowrap">Quotation Type</th>
                    <th className="py-2 md:py-3 px-2 md:px-3 text-start text-xs md:text-base whitespace-nowrap">Insurance Provider</th>
                    <th className="py-2 md:py-3 px-2 md:px-3 text-start text-xs md:text-base whitespace-nowrap">Insurance Expiry</th>
                    <th className="py-2 md:py-3 px-2 md:px-3 text-start text-xs md:text-base whitespace-nowrap">Finalised Sum Insured</th>
                </tr>
            </thead>
            <tbody>
                {data?.length > 0 ? (
                    data?.map((item, index) => (
                        <tr className="border-gray-200 border text-[#212121]" key={index}>
                            <td className="py-2 md:py-3 px-2 md:px-3 text-start text-xs md:text-base whitespace-nowrap">{item.ref_id}</td>
                            <td className="py-2 md:py-3 px-2 md:px-3 text-start text-xs md:text-base whitespace-nowrap">{item.coverage_type}</td>
                            <td className="py-2 md:py-3 px-2 md:px-3 text-start text-xs md:text-base whitespace-nowrap">{item.quotation_type}</td>
                            <td className="py-2 md:py-3 px-2 md:px-3 text-start text-xs md:text-base whitespace-nowrap">{item.insurance_provider}</td>
                            <td className="py-2 md:py-3 px-2 md:px-3 text-start text-xs md:text-base whitespace-nowrap">{item.insurance_expiry}</td>
                            <td className="py-2 md:py-3 px-2 md:px-3 text-start text-xs md:text-base whitespace-nowrap">MYR {formatCurrency(item.finalised_sum_insured)}</td>
                        </tr>
                    ))
                ) : (
                    <tr>
                        <td className="py-2 md:py-3 px-2 md:px-3 text-start text-xs md:text-base">-</td>
                        <td className="py-2 md:py-3 px-2 md:px-3 text-start text-xs md:text-base">-</td>
                        <td className="py-2 md:py-3 px-2 md:px-3 text-start text-xs md:text-base">-</td>
                        <td className="py-2 md:py-3 px-2 md:px-3 text-start text-xs md:text-base">-</td>
                        <td className="py-2 md:py-3 px-2 md:px-3 text-start text-xs md:text-base">-</td>
                        <td className="py-2 md:py-3 px-2 md:px-3 text-start text-xs md:text-base">-</td>
                    </tr>
                )}
            </tbody>
        </table>
        </div>
    )
}
const AssociatedFinancingInformation = ({data}) => {
    return(
        <div className="overflow-x-auto w-full">
        <table className="min-w-full bg-white border border-gray-200">
            <thead>
                <tr className="bg-gray-100 border-none text-[#94A3B8]">
                    <th className="py-2 md:py-3 px-2 md:px-3 text-start text-xs md:text-base whitespace-nowrap">Financing Type</th>
                    <th className="py-2 md:py-3 px-2 md:px-3 text-start text-xs md:text-base whitespace-nowrap">Financing Type (Other)</th>
                    <th className="py-2 md:py-3 px-2 md:px-3 text-start text-xs md:text-base whitespace-nowrap">Partner</th>
                    <th className="py-2 md:py-3 px-2 md:px-3 text-start text-xs md:text-base whitespace-nowrap">Partner (Other)</th>
                    <th className="py-2 md:py-3 px-2 md:px-3 text-start text-xs md:text-base whitespace-nowrap">Approved Date</th>
                    <th className="py-2 md:py-3 px-2 md:px-3 text-start text-xs md:text-base whitespace-nowrap">Approved Amount</th>
                </tr>
            </thead>
            <tbody>
                {data.length > 0 ? (
                    data.map((item, index) => (
                        <tr className="border-gray-200 border text-[#212121]" key={index}>
                            <th className="py-2 md:py-3 px-2 md:px-3 text-start text-xs md:text-base whitespace-nowrap">{item.type}</th>
                            {item.type === 'Others' ? <th className="py-2 md:py-3 px-2 md:px-3 text-start text-xs md:text-base whitespace-nowrap">{item.type_other}</th> : <th className="py-2 md:py-3 px-2 md:px-3 text-start text-xs md:text-base whitespace-nowrap">-</th>}
                            <th className="py-2 md:py-3 px-2 md:px-3 text-start text-xs md:text-base whitespace-nowrap">{item.partner}</th>
                            {item.partner === 'Others' ? <th className="py-2 md:py-3 px-2 md:px-3 text-start text-xs md:text-base whitespace-nowrap">{item?.partner_other}</th> : <th className="py-2 md:py-3 px-2 md:px-3 text-start text-xs md:text-base whitespace-nowrap">-</th>}
                            <th className="py-2 md:py-3 px-2 md:px-3 text-start text-xs md:text-base whitespace-nowrap">{item.approved_at}</th>
                            <th className="py-2 md:py-3 px-2 md:px-3 text-start text-xs md:text-base whitespace-nowrap">MYR {formatCurrency(item.approved_amt)}</th>
                        </tr>
                    ))
                ) : (
                    <tr className="border-gray-200 border text-[#212121]">
                        <th className="py-2 md:py-3 px-2 md:px-3 text-start text-xs md:text-base">-</th>
                        <th className="py-2 md:py-3 px-2 md:px-3 text-start text-xs md:text-base">-</th>
                        <th className="py-2 md:py-3 px-2 md:px-3 text-start text-xs md:text-base">-</th>
                        <th className="py-2 md:py-3 px-2 md:px-3 text-start text-xs md:text-base">-</th>
                        <th className="py-2 md:py-3 px-2 md:px-3 text-start text-xs md:text-base">-</th>
                        <th className="py-2 md:py-3 px-2 md:px-3 text-start text-xs md:text-base">-</th>
                    </tr>
                )}
            </tbody>
        </table>
        </div>

    )
}
const AssociatedOpportunities = ({data}) =>{
    return(
        <div className="overflow-x-auto w-full">
        <table className="min-w-full bg-white border border-gray-200">
            <thead>
                <tr className="bg-gray-100 border-none text-[#94A3B8]">
                    <th className="py-2 md:py-3 px-2 md:px-3 text-start text-xs md:text-base whitespace-nowrap">Opp ID</th>
                    <th className="py-2 md:py-3 px-2 md:px-3 text-start text-xs md:text-base">Title</th>
                </tr>
            </thead>
            <tbody>
                {data.length > 0 ? (
                    data.map((item, index) => (
                        <tr className="border-gray-200 border text-[#212121]" key={index}>
                            <th className="py-2 md:py-3 px-2 md:px-3 text-start text-xs md:text-base whitespace-nowrap">{item.opp_id}</th>
                            <th className="py-2 md:py-3 px-2 md:px-3 text-start text-xs md:text-base">{item.title}</th>
                        </tr>
                    ))
                ) : (
                    <tr className="border-gray-200 border text-[#212121]">
                        <th className="py-2 md:py-3 px-2 md:px-3 text-start text-xs md:text-base">-</th>
                        <th className="py-2 md:py-3 px-2 md:px-3 text-start text-xs md:text-base">-</th>
                    </tr>
                )}
            </tbody>
        </table>
        </div>
    )
}

export {AssociatedInsuranceInformation, AssociatedFinancingInformation, AssociatedOpportunities};
